export default "__VITE_ASSET__ba536e5f__"